import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GalleryView } from 'app/views';
import { useDownloadSelection } from 'src/react/shared/molecules/DownloadSelection';

export default () => {
  const gallery = useSelector((state) => state.gallery);
  // galleryPolicy can't call hooks, so the selection reaches it through here.
  const selection = useDownloadSelection()?.selection;
  const hasDownloadSelection = Boolean(selection && !selection.isEmpty());

  return useMemo(
    () => new GalleryView({ ...gallery, hasDownloadSelection }),
    [gallery, hasDownloadSelection]
  );
};
